import React, { Component, Fragment } from "react";
import { I18n } from "aws-amplify";
import { connect } from "react-redux";
import constants from "../../../constants";
import { Link, Redirect } from "react-router-dom";
import AppWrapperSimple from "../../components/AppWrapperSimple";
import ContainerPage from "../../components/ContainerPage";
import SubHeader from "../../components/SubHeader";

import { PartnerStatus } from "../../../model";

import { LEADER_API } from "../../../actions/leader/actions";

import FormExpertise from "../components/formExpertise";

import { TitleBorder, TitleMiddleLine } from "../../components/Titles";

import FormSkeleton from "../../components/FormSkeleton";

import styled from "styled-components";

import { QueryString } from "../../../utils/querystring";

import {
  Row,
  Col,
  Input,
  Table,
  Icon,
  Select,
  Button,
  Tooltip,
  Form,
  Drawer,
  notification,
} from "antd";

const { TextArea } = Input;
const { Option } = Select;

const Btns = styled.p`
  a {
    margin-left: 10px;
  }
`;

const Main = styled.div`
  padding-top: 50px;
  padding-bottom: 90px;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;

  .BtnAction {
    margin-bottom: 20px;
    text-align: right;
  }

  .RowSection {
    margin-bottom: 60px;
  }
`;
const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMarketExpertise: (data) => {
      dispatch(LEADER_API.create_expertise(data));
    },
    delMarketExpertise: (data) => {
      dispatch(LEADER_API.delete_expertise(data));
    },
    updateMarketExpertise: (data) => {
      dispatch(LEADER_API.update_expertise(data));
    },
    confirm: (data) => {
      dispatch(LEADER_API.confirm(data));
    },
  };
};

class LeaderExpertise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: null,
      edit: false,
      show: false,
      type: 1,
    };
  }

  hideExpertise = () => {
    this.setState({
      selectedItem: null,
      edit: false,
      show: false,
    });
  };

  showAddExpertise = (type) => {
    this.setState({
      selectedItem: null,
      edit: false,
      show: true,
      type: type,
    });
  };

  showEditExpertise = (item) => {
    this.setState({
      selectedItem: item,
      edit: true,
      show: true,
      type: item.type,
    });
  };

  getSector = (sectorId) => {
    const items =
      this.props.bp.sectorsFlat &&
      this.props.bp.sectorsFlat.filter((item) => item.code == sectorId);

    if (items && items.length) {
      return items[0].label;
    } else {
      return {};
    }
  };

  updateExpertise = (data) => {
    let x = {
      PartnerMarketExpertise: data,
      Locale: this.state.locale,
    };

    this.props.updateMarketExpertise(x);
  };

  addExpertise = (data) => {
    let x = {
      PartnerMarketExpertise: data,
      Locale: this.state.locale,
    };

    this.props.addMarketExpertise(x);
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps) return;
    if (!prevState) return;

    if (
      this.props.leader.marketExpertises &&
      prevProps.leader.marketExpertises &&
      this.props.leader.marketExpertises.length >
        prevProps.leader.marketExpertises.length
    ) {
      notification.success({
        message: I18n.get("Adicionado com sucesso!"),
        description: I18n.get(
          "O mercado de expertise foi adicionado ao seu cadastro"
        ),
        duration: 3,
      });

      this.hideExpertise();
    }

    if (
      this.props.leader.marketExpertises &&
      prevProps.leader.marketExpertises &&
      this.props.leader.marketExpertises.length <
        prevProps.leader.marketExpertises.length
    ) {
      notification.success({
        message: I18n.get("Removido com sucesso!"),
        description: I18n.get(
          "O mercado de expertise foi removido do seu cadastro"
        ),
        duration: 3,
      });
    }

    if (
      this.props.leader.marketExpertises &&
      prevProps.leader.marketExpertises &&
      this.props.leader.marketExpertises != prevProps.leader.marketExpertises &&
      this.state.selectedItem
    ) {
      notification.success({
        message: I18n.get("Atualizado com sucesso!"),
        description: I18n.get("O mercado de expertise foi atualizado"),
        duration: 3,
      });

      this.setState({
        selectedItem: null,
      });

      this.hideExpertise();
    }
  }

  componentDidMount = () => {
    var query = QueryString.extract(this.props.location.search);

    let locale = query.locale || "pt";

    this.setState({ locale: locale });

    I18n.setLanguage(locale);

    let data = {
      verificationToken: this.props.match.params.token,
      locale: locale,
    };

    this.props.confirm(data);
  };

  render() {
    if (this.props.leader && this.props.leader.completedOn) {
      return <Redirect to="/parceiro/obrigado" />;
    }

    let dataType2 =
      this.props.leader.marketExpertises &&
      this.props.leader.marketExpertises
        .filter((item) => item.type == 2)
        .map((item, index) => {
          return {
            key: index,
            expertise: item.sectorId,
            anos: item.years,
            meses: item.months,
            marcas: item.brands,
            item: item,
          };
        });

    const columns = [
      {
        title: I18n.get("Expertise"),
        dataIndex: "expertise",
        key: "expertise",
        render: (expertise) => this.getSector(expertise),
      },
      {
        title: I18n.get("Anos"),
        dataIndex: "anos",
        key: "anos",
      },
      {
        title: I18n.get("Meses"),
        dataIndex: "meses",
        key: "meses",
      },
      {
        title: I18n.get("Marcas"),
        dataIndex: "marcas",
        key: "marcas",
      },
      {
        title: "",
        dataIndex: "action",
        key: "item",
        render: (text, record) => {
          let data = {
            id: record.item.id,
            leaderId: this.props.match.params.leaderId,
          };

          return (
            <Btns>
              <a onClick={() => this.props.delMarketExpertise(data)}>
                <Icon type="delete" theme="filled" />
              </a>
              <a onClick={() => this.showEditExpertise(record.item)}>
                <Icon type="edit" theme="filled" />
              </a>
            </Btns>
          );
        },
      },
    ];

    //TODO: Find better way... GAMBI!
    let menu = [...constants.MENU_REGISTER_LEADERS];
    for (let key in menu) {
      menu[key].label = I18n.get(menu[key].label);
    }

    return (
      <AppWrapperSimple>
        <SubHeader
          titlePage=""
          itensMenu={menu}
          urlId={
            this.props.match.params.leaderId +
            "/" +
            this.props.match.params.token
          }
          activeItem={2}
          locale={this.state.locale}
        />
        <ContainerPage>
          <Main>
            <Row>
              <Col sm={24}>
                <TitleBorder>
                  {I18n.get("Líder - mercados de expertise")}
                </TitleBorder>
                <p className="descriptionPage">
                  {this.props.leader.name ? `${this.props.leader.name}! ` : ""}{" "}
                  {I18n.get(
                    "Nosso algoritmo quer saber mais sobre você, que está na liderança. Lembre-se de que cada informação é valiosa para ele encontrar projetos que tenham a ver com sua empresa."
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <TitleMiddleLine>
                  {I18n.get(
                    "Indique pelo menos 3 principais mercados de expertise em sua carreira"
                  )}
                  <Tooltip
                    title={I18n.get(
                      "Acreditamos que um expertise de uma empresa é sempre mais completo quando soma o expertise de carreira do time"
                    )}
                  >
                    <Icon type="question-circle" theme="filled" />
                  </Tooltip>
                </TitleMiddleLine>
              </Col>
            </Row>

            <Row>
              <Col sm={24}>
                <p className="BtnAction">
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => this.showAddExpertise(2)}
                  >
                    {I18n.get("+ Adicionar expertise")}
                  </Button>
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Table
                  scroll={{ x: 640 }}
                  locale={{ emptyText: I18n.get("Sem informação") }}
                  columns={columns}
                  dataSource={dataType2}
                />
              </Col>
            </Row>

            <Row className="RowSection">
              <Col sm={8}></Col>
            </Row>

            <Row>
              <Col sm={3}>
                <Link
                  to={`/lider/cadastro/sobre-voce/${this.props.match.params.leaderId}/${this.props.match.params.token}?locale=${this.state.locale}`}
                >
                  <Button shape="round">{I18n.get("Voltar")}</Button>
                </Link>
              </Col>
              <Col sm={18}></Col>
              <Col sm={3}>
                <Link
                  to={`/lider/cadastro/trabalhos/${this.props.match.params.leaderId}/${this.props.match.params.token}?locale=${this.state.locale}`}
                >
                  <Button type="primary" shape="round">
                    {I18n.get("Avançar")}
                  </Button>
                </Link>
              </Col>
            </Row>
          </Main>
        </ContainerPage>

        <Drawer
          title={
            this.state.selectedItem
              ? I18n.get("Editar expertise")
              : I18n.get("Adicionar expertise")
          }
          placement="right"
          forceRender={true}
          closable={true}
          onClose={() => this.hideExpertise()}
          destroyOnClose={true}
          visible={this.state.show}
          width="40%"
        >
          <FormExpertise
            isLeader={true}
            partner={this.props.leader && this.props.leader}
            partnerId={this.props.match.params.leaderId}
            action={this.addExpertise}
            update={this.updateExpertise}
            cancel={() => this.hideExpertise()}
            type={2}
            item={this.state.selectedItem}
            sectorsFlat={this.props.bp.sectorsFlat && this.props.bp.sectorsFlat}
            errors={this.props.leader.errors && this.props.leader.errors}
          />
        </Drawer>
      </AppWrapperSimple>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaderExpertise);
